<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="fm02">
<header><h1 class="h1b" id="fm02"><span aria-label=" Page xvi. " epub:type="pagebreak" id="page_xvi" role="doc-pagebreak">NOTE TO READER</span></h1></header>
<p class="noindent">Note numbers with an asterisk indicate further discussion on a topic that the reader is encouraged to peruse.</p>
<p class="indent">The Glossary contains definitions of ideas that may be unfamiliar to the reader and terms that have been used in the book in a particular way.</p>
<p class="indent">Further Reading contains suggestions for those who wish to explore the topics of each chapter in more depth.<span aria-label=" Page xvii. " epub:type="pagebreak" id="page_xvii" role="doc-pagebreak"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?9a31c98a